import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./icons.js";
import { colors } from "./theme.js";
import { venueShortName, venueColor } from "../../lib/venue-names.js";
/**
 * A venue label with its deterministic colour — a tinted pill with a map-pin,
 * mirroring CredentialChip so venues and credentials read as one visual system.
 */
export function VenueChip({ venueId, maxWidth = 180, style, }) {
    if (!venueId)
        return null;
    const color = venueColor(venueId);
    const name = venueShortName(venueId);
    return (_jsxs("span", { title: name, style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            padding: "2px 8px",
            borderRadius: 999,
            background: `${color}1A`,
            border: `1px solid ${color}55`,
            color: colors.text,
            fontSize: "0.74rem",
            fontWeight: 600,
            maxWidth,
            ...style,
        }, children: [_jsx(Icon, { name: "map-pin", size: 12, color: color }), _jsx("span", { style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: name })] }));
}
